module.exports = __webpack_public_path__ + "static/media/MTB.ddf9f44d.jpg";